import React, { useState, useEffect } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";

// components imports
import ApprovedPaymentList from "../../Shipper/Customer/MainPages/Payments/Components/ApprovedPaymentList/ApprovedPaymentList";
import PendingPaymentList from "../../Shipper/Customer/MainPages/Payments/Components/PendingPaymentList/PendingPaymentList";
import Invoices from "../../Shipper/Customer/MainPages/Payments/Components/Invoices/Invoices";
import Taxes from "../../Shipper/Customer/MainPages/Payments/Components/Taxes/Taxes";

// library imports

import { useSelector } from "react-redux";
import TabsComponent from "../../../Components/Common/TabsComponent";
import { initialPaymentTab } from "../../../data/permissionsArray";
import { useTranslation } from "react-i18next";

const CarrierFinances = () => {
  const { t } = useTranslation("carrier");
  const [tab, setTab] = useState(0);
  const [tabPermissions, setTabPermissions] = useState(initialPaymentTab);

  const user = useSelector((state) => state.user);
  const setSnack = useSnackBar();

  useEffect(() => {
    if (user.role != "Shipper") {
      let validPermissions = initialPaymentTab.filter((t) =>
        user?.mergedPermissions?.includes(t.name),
      );
      if (validPermissions?.length > 0) {
        setTab(validPermissions[0]?.value);
      } else {
        // setTab("nothing");
        setTab(0);
      }
      setTabPermissions(validPermissions);
    } else {
      setTab(0);
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >

      <TabsComponent
        items={[
          { label: t("finances.approvedCaps"), style: { fontWeight: "bold" }, value: 0 },
          { label: t("finances.pendingCaps"), style: { fontWeight: "bold" }, value: 1 },
          { label: t("finances.invoicesCaps"), style: { fontWeight: "bold" }, value: 2 },
          { label: t("finances.taxesCaps"), style: { fontWeight: "bold" }, value: 3 },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
      />
      {tab === 0 && <ApprovedPaymentList setSnack={setSnack} />}
      {tab === 1 && <PendingPaymentList setSnack={setSnack} />}
      {tab === 2 && <Invoices setSnack={setSnack} />}
      {tab === 3 && <Taxes setSnack={setSnack} />}
    </div>
  );
};

export default CarrierFinances;
